










































import { ParagraphSize, AvatarSize } from '@getaccept/lib-ui';
import type { PropType } from '@vue/composition-api';
import { defineComponent, ref } from '@vue/composition-api';
import type { ChatComment } from '../types/chat-comment';

export default defineComponent({
  props: {
    comment: {
      type: Object as PropType<ChatComment>,
      default: () => ({}),
    },
    name: {
      type: String,
      default: '',
    },
    thumbUrl: {
      type: String,
      default: '',
    },
    fullTimestamp: {
      type: String,
      default: '',
    },
    showName: {
      type: Boolean,
    },
    first: {
      type: Boolean,
    },
    last: {
      type: Boolean,
    },
    showDelete: {
      type: Boolean,
    },
  },
  setup() {
    const showMessageTimestamp = ref(false);

    const hideTimestamp = () => {
      showMessageTimestamp.value = false;
    };

    return {
      ParagraphSize,
      AvatarSize,
      showMessageTimestamp,
      hideTimestamp,
    };
  },
});
